export const objectTypesEnum = {
  Location: 'Location',
  AssetPosition: 'AssetPosition',
  Asset: 'Asset',
} as const

export type ObjectTypesEnum = (typeof objectTypesEnum)[keyof typeof objectTypesEnum]

export type ObjectTypes = ObjectTypesEnum